import {useCallback, useState, UIEvent} from 'react'

export const useTableScrollState = () => {
  const [scrollDirection, setScrollDirection] = useState({
    scrollingRight: false,
    scrollingLeft: false
  })

  const handleScroll = useCallback((event: UIEvent<HTMLDivElement>) => {
    const target = event.target as HTMLDivElement
    const maxScrollLeft = target.scrollWidth - target.clientWidth
    const scrolledFromRight = maxScrollLeft - target.scrollLeft
    setScrollDirection({
      scrollingRight: target.scrollLeft > 0,
      scrollingLeft: scrolledFromRight > 0
    })
  }, [])

  return {
    scrollingRight: scrollDirection.scrollingRight,
    scrollingLeft: scrollDirection.scrollingLeft,
    handleScroll
  }
}
